import { useCallback, useEffect, useMemo, useState } from 'react' //ChangeEvent


// Components
import { Skeleton } from 'components/skeleton'
import { TradePair } from 'components/tradePair'
import { Warning } from 'components/warning'
import { Switch } from 'components/switchBuy'
import { PendingBuysButton } from 'components/pendingBuysButton'

// Constants
import {
  APPROVE_ERROR_TOAST,
  APPROVE_SUCCESS_TOAST,
  APPROVE_ETH_SUCCESS_TOAST,
  APPROVE_ETH_ERROR_TOAST,
  ERROR_TOAST,
  SHARES_INFO,
  SUCCESS_TOAST,
  SUCCESS_TOAST_DEMAND,
  SUCCESS_TOAST_BurnAndBridge,
} from './buyCrypto.constants'

import { supportedChains } from 'components/navbar/navbar.constants'


// Styles
import {
  ButtonContainer,
  ButtonRow,
  BuyButton,
  BuyCard,
  BuyForm,
  ExchangeRate,
  //HalfFont,
  RateIcon,
  TotalDiscount,
  UnderPairRow,
  DiscountWrapp,
  BuySelectContainer,
  BuySelect
} from './buyCrypto.styled'

// Hooks
import { useSafePOKTContext } from 'providers/SafePOKTProvider'
import { useToasts } from 'providers/ToastProvider'
import { useReady, useBridge } from 'hooks/useReady'
import { useWalletContext } from 'providers/WalletProvider'
import { useSpendableTokenContext } from 'providers/SpendableTokenProvider'

// Types
import { TransactionResponse } from '@ethersproject/abstract-provider'

// Utils
import {
 // applyDiscountToShares,
 // applyDiscountToUSDC,+
  USDCtoSHARESdiscount2,
  SHAREStoUSDCdiscount,
  DiscountConstants,
  getDisabledInfo,
  getDisabledInfoEth,
} from './buyCrypto.utils'
import { Button } from 'components/button'
import { SHARES_PER_NODE } from 'hooks/useSafePOKT/useSafePOKT.constants'
import { numberFormatter } from 'utils'

interface BuyCryproProps {
  isDisabled: boolean
  isDisabledEth: boolean
  realPoktPrice: number
}

export const BuyCrypto = ({ isDisabled, isDisabledEth, realPoktPrice }: BuyCryproProps) => {

  
  const [isTransacting, setIsTransacting] = useState(false)
    // Var declaration USDC
  const [currentAllowance, setAllowance] = useState(0)
  const [buyInputs, setBuyInputs] = useState({ USDC: '0', SHARES: '0' })
    // Var declaration WPOKT
  const [currentAllowanceEth, setAllowanceEth] = useState(0)
  const [buyInputsEth, setBuyInputsEth] = useState({ WPOKT: '0', SHARES: '0' })

    // Context declarations
  const { currentAccount, chainId } = useWalletContext()
  const { interactionsUSDC , interactionsWpoktEth, balanceUSDC, balanceWpoktEth, refreshParamsUSDC, refreshParamsWpoktEth, WpoktAddress, BuyWPOKTDestination} = useSpendableTokenContext()
  const safePokt = useSafePOKTContext()
  const isReady = useReady()
  const isBridge = useBridge()

  const [switchValue, setSwitchValue] = useState(false)

  const chains: string[] = supportedChains;
  const [firstSelect, setFirstSelect] = useState(chains[0]);

  const { newToast } = useToasts()

  const getAllowance = useCallback(() => {
    if (isReady && currentAccount && safePokt.address) {
      interactionsUSDC.allowance(currentAccount, safePokt.address).then((newAllowance) => {
        setAllowance(Number(newAllowance))
      }).catch(err => {
          if ( !(err as any).message || !(err as any).message.includes("underlying network changed") ) console.log(err)
       });
    }
  }, [isReady, currentAccount, safePokt.address, interactionsUSDC])

  const getAllowanceEth = useCallback(() => {
      if (isBridge && currentAccount && WpoktAddress) {
          interactionsWpoktEth.allowance(currentAccount, WpoktAddress).then((newAllowance) => {
            setAllowanceEth(Number(newAllowance))
          }).catch(err => { 
            if ( !(err as any).message || !(err as any).message.includes("underlying network changed") ) console.log(err)
          });
      }
  }, [isBridge, currentAccount, WpoktAddress, interactionsWpoktEth])

  useEffect(() => {
      try {
          getAllowance()
      } catch (err) { console.log(err) }
  }, [getAllowance])

  useEffect(() => {
      try {
          getAllowanceEth()
      } catch (err) { console.log(err) }
  }, [getAllowanceEth])

  const hasEnoughAllowance = useMemo(
    () => currentAllowance > Number(buyInputs.USDC),
    [currentAllowance, buyInputs]
  )

  const hasEnoughAllowanceEth = useMemo(
    () => currentAllowanceEth > Number(buyInputsEth.WPOKT),
    [currentAllowanceEth, buyInputsEth]
  )

  const [hasEnoughBalance, minDemandAmount] = useMemo(
      () => {
          const usdc = Number(buyInputs.USDC)
          let enoughMinAmount = false
          if (switchValue) {
              enoughMinAmount = (safePokt.BuyDemandMinAmount > usdc)
          }
          return [balanceUSDC >= usdc, enoughMinAmount]
      },
    [balanceUSDC, buyInputs.USDC, safePokt.BuyDemandMinAmount, switchValue]
  )

  const hasEnoughBalanceEth = useMemo(
      () => {
          const wpokt = Number(buyInputsEth.WPOKT)
          return (balanceWpoktEth >= wpokt)
      },
     [balanceWpoktEth, buyInputsEth.WPOKT]
    )

  const disabledInfo = useMemo(
    () =>
      !safePokt.isLoading &&
      getDisabledInfo(
        !isReady,
        !safePokt.holderActionsEnabled,
        hasEnoughBalance,
        minDemandAmount,
        safePokt.BuyDemandMinAmount,
      ),
    [
      isReady,
      safePokt.holderActionsEnabled,
      hasEnoughBalance,
      safePokt.isLoading,
      minDemandAmount,
      safePokt.BuyDemandMinAmount,
    ]
  )

  const disabledInfoEth = useMemo(
      () =>
          !safePokt.isLoading &&
          getDisabledInfoEth(
             !isBridge,
             !safePokt.holderActionsEnabled,
              hasEnoughBalanceEth,
          ),
        [
            isBridge,
            safePokt.holderActionsEnabled,
            hasEnoughBalanceEth,
            safePokt.isLoading,
            //NEED TO ADD TO WPOKT.isLOADING
        ]
    )

  const setBuyInputValue = useCallback((name: string, newValue: string) => {
    const roundedNewValue = newValue
      ? (Math.round((Number(newValue) + Number.EPSILON) * 100) / 100).toString()
      : newValue

    setBuyInputs((current) => ({
      ...current,
      [name]: roundedNewValue,
    }))
  }, [])

  const setBuyInputValueEth = useCallback((name: string, newValue: string) => {
    const roundedNewValue = newValue
      ? (Math.round((Number(newValue) + Number.EPSILON) * 100) / 100).toString()
      : newValue

    setBuyInputsEth((current) => ({
       ...current,
      [name]: roundedNewValue,
    }))
 }, [])

  const onSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault()
      if (safePokt && hasEnoughBalance) {
        if (hasEnoughAllowance) {
          try {
            
            if (!switchValue) {
                setIsTransacting(true)
                const transaction = await safePokt.buyPokt(Math.floor(Number(buyInputs.SHARES)))
                refreshParamsUSDC()
                newToast(SUCCESS_TOAST, transaction.hash)
                setIsTransacting(false)
                setBuyInputValue('SHARES', '0')
                setBuyInputValue('USDC', '0')
            } else {
                setIsTransacting(true)
                const transaction = await safePokt.buyPoktOnDemand(Math.floor(Number(buyInputs.USDC)))
                refreshParamsUSDC()
                newToast(SUCCESS_TOAST_DEMAND, transaction.hash)
                setIsTransacting(false)
                setBuyInputValue('SHARES', (safePokt.BuyDemandMinAmount/(realPoktPrice*safePokt.getPoktPerShare)).toString())
                setBuyInputValue('USDC', safePokt.BuyDemandMinAmount.toString())
            }
           
          } catch (error) {
            console.error(error)
            newToast(ERROR_TOAST, (error as TransactionResponse).hash)
            setIsTransacting(false)
          }
        }
      }
    },
    [
      safePokt,
      buyInputs,
      newToast,
      refreshParamsUSDC,
      hasEnoughAllowance,
      hasEnoughBalance,
      setBuyInputValue,
      switchValue,
      realPoktPrice,
    ]
  )

  const onSubmitEth = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault()
      if (interactionsWpoktEth && hasEnoughBalanceEth) {
        if (hasEnoughAllowanceEth) {
          try {
                setIsTransacting(true)
                const transaction = await interactionsWpoktEth.burnAndBridge(Number(buyInputsEth.WPOKT), BuyWPOKTDestination)
                refreshParamsWpoktEth()
                newToast(SUCCESS_TOAST_BurnAndBridge, transaction.hash)
                setIsTransacting(false)
                setBuyInputValueEth('SHARES', '0')
                setBuyInputValueEth('WPOKT', '0')

          } catch (error) {
            console.error(error)
            newToast(ERROR_TOAST, (error as TransactionResponse).hash)
            setIsTransacting(false)
        }
      }
   }
  },
    [
      interactionsWpoktEth,
      hasEnoughBalanceEth,
      hasEnoughAllowanceEth,
      buyInputsEth.WPOKT,
      BuyWPOKTDestination,
      newToast,
      refreshParamsWpoktEth,
      setBuyInputValueEth,
    ]
  )

  const onApprove = useCallback(async (e) => {
    e.preventDefault()
    if (safePokt.address) {
      try {
        setIsTransacting(true)
        const approveTransaction = await interactionsUSDC.approve(
          safePokt.address,
          99999999999999
        )
        getAllowance()
        newToast(APPROVE_SUCCESS_TOAST, approveTransaction.hash)
        setIsTransacting(false)
      } catch (error) {
        console.error(error)
        newToast(APPROVE_ERROR_TOAST, (error as TransactionResponse).hash)
        setIsTransacting(false)
      }
    } else {
      newToast(APPROVE_ERROR_TOAST)
    }
  }, [safePokt.address, interactionsUSDC, newToast, getAllowance])

  const onApproveEth = useCallback(async (e) => {
      e.preventDefault()
    if (WpoktAddress) {
        try {
            setIsTransacting(true)
            const approveTransaction = await interactionsWpoktEth.approve(
                WpoktAddress,
                99999999999999
            )
            getAllowanceEth()
            newToast(APPROVE_ETH_SUCCESS_TOAST, approveTransaction.hash)
            setIsTransacting(false)
        } catch (error) {
            console.error(error)
            newToast(APPROVE_ETH_ERROR_TOAST, (error as TransactionResponse).hash)
            setIsTransacting(false)
        }
    } else {
        newToast(APPROVE_ERROR_TOAST)
    }
  }, [WpoktAddress, interactionsWpoktEth, newToast, getAllowanceEth])

  const [maxDiscountShares, exchangeRate, DSharesPerNode] = useMemo(
    () => {
        const maxDiscountShares = safePokt.BuyDemandMinAmount * (1 / (safePokt.poktBuyPrice * safePokt.getPoktPerShare))          
        const exchangeRate = 1 / (safePokt.poktBuyPrice * safePokt.getPoktPerShare)
        const sharesPerNode = SHARES_PER_NODE / safePokt.getPoktPerShare
          
        return [maxDiscountShares, exchangeRate, sharesPerNode]

    }, [safePokt.BuyDemandMinAmount, safePokt.poktBuyPrice, safePokt.getPoktPerShare]
  )

  /*const onComputeDiscount = useCallback(async (shares: number) => {
    if (safePokt) {
        try {
        if (shares > maxDiscountShares) shares = maxDiscountShares
        const discount = await safePokt.computeDiscount(Math.floor(shares))
        return Number(discount)

        } catch (error) {
        console.error(error)

        }
    }
    return Number(0) 
  }, [safePokt, maxDiscountShares])*/

  const [sharePrice, totaldiscountUSDC, discountPercentage] =
    useMemo( () => {

    let sharePrice, discount, discountPercentage
    if (!switchValue) {
      [sharePrice, discount, discountPercentage] = DiscountConstants(Number(buyInputs.SHARES), safePokt.BuyDemandMinAmount, maxDiscountShares, safePokt.nodeDiscount, exchangeRate)
      
    } else {
      sharePrice = realPoktPrice * safePokt.getPoktPerShare //POKT PRICE
      discountPercentage = 0
      discount = 0
    }    

    return [sharePrice, discount, discountPercentage]

  }, [buyInputs.SHARES, exchangeRate, safePokt.nodeDiscount, maxDiscountShares, switchValue, realPoktPrice, safePokt.getPoktPerShare, safePokt.BuyDemandMinAmount ])

    const sharePriceEth = useMemo(() => {

        return (Number(safePokt.getPoktPerShare))

    }, [safePokt.getPoktPerShare])

  const onTradeInputChange: React.ChangeEventHandler<HTMLInputElement> =
    useCallback(
        (e) => {
            if (!switchValue) {
                if (e.target.name === 'SHARES') {
                    const shares = e.target.value
                    setBuyInputValue('SHARES', shares)

                    const totalusdc = SHAREStoUSDCdiscount(
                        Number(shares),
                        maxDiscountShares,
                        safePokt.nodeDiscount,
                        safePokt.poktBuyPrice,
                        safePokt.getPoktPerShare
                    )

                    setBuyInputValue('USDC', totalusdc.toString())
                    // onComputeDiscount(shares).then(discount => {
                    //     const totalusdc = shares / exchangeRate
                    //     discount /= 1000000
                    //     console.log("Discount"+discount)
                    //     setBuyInputValue('USDC', (totalusdc-discount).toString() )
                    // }).catch(err => {
                    //     console.log(err)
                    // })

                } else {
                    const usdc = e.target.value
                    setBuyInputValue('USDC', usdc)

                    const totalShares = USDCtoSHARESdiscount2(
                        Number(usdc),
                        safePokt.BuyDemandMinAmount,
                        maxDiscountShares,
                        safePokt.nodeDiscount,
                        safePokt.poktBuyPrice,
                        safePokt.getPoktPerShare
                    )


                    setBuyInputValue('SHARES', totalShares.toString())
                    //onComputeDiscount((usdc * exchangeRate)).then(discount => {
                    // discount /= 1000000
                    //  const discountShares = discount * exchangeRate
                    //  console.log("discount"+discount)
                    // setBuyInputValue('SHARES', (totalShares + discountShares).toString())
                    //}).catch(err => {
                    // console.log(err)
                    //})
                }
            } else {
                if (e.target.name === 'USDC') {
                    const usdc = e.target.value
                    setBuyInputValue('USDC', usdc)
                    const shares = Number(usdc) / (realPoktPrice * safePokt.getPoktPerShare)
                    setBuyInputValue('SHARES', shares.toString())
                }
            }
        }, [    setBuyInputValue,
                maxDiscountShares,
                safePokt.nodeDiscount,
                safePokt.getPoktPerShare,
                safePokt.poktBuyPrice,
                safePokt.BuyDemandMinAmount,
                switchValue,
                realPoktPrice,
            ]
      )

    const onTradeInputChangeEth: React.ChangeEventHandler<HTMLInputElement> =
        useCallback(
            (e) => {
                if (e.target.name === 'WPOKT') {
                    const wpokt = e.target.value
                    setBuyInputValueEth('WPOKT', wpokt)
                    const shares = Number(wpokt) / safePokt.getPoktPerShare
                    setBuyInputValueEth('SHARES', shares.toString())
                } else if (e.target.name === 'SHARES') {
                    const shares = e.target.value
                    setBuyInputValueEth('SHARES', shares)
                    const wpokt = Number(shares) * safePokt.getPoktPerShare
                    setBuyInputValueEth('WPOKT', wpokt.toString())
                }
                
            }, [
                  setBuyInputValueEth,
                  safePokt.getPoktPerShare,
            ]
        )

    const handleSwitchValueChange = (value: boolean) => {
        setSwitchValue(value);
        const usdc = Number(buyInputs.USDC)
        if (!switchValue) { //ON
            const shares = usdc / (realPoktPrice * safePokt.getPoktPerShare)
            setBuyInputValue('SHARES', shares.toString())

        } else { //OFF
            const totalShares = USDCtoSHARESdiscount2(
                usdc,
                safePokt.BuyDemandMinAmount,
                maxDiscountShares,
                safePokt.nodeDiscount,
                safePokt.poktBuyPrice,
                safePokt.getPoktPerShare
            )
            setBuyInputValue('SHARES', totalShares.toString())
           
        }
    }

    const buttonsDisabled = !isReady || isTransacting

    const buttonsDisabledEth = !isBridge || isTransacting

  return (
      <BuyCard title={'Buy Shares'} info={SHARES_INFO} className1="buytitle" buyMargin={!isBridge}>
       <BuySelectContainer>
          <BuySelect options={chains} value={firstSelect} dropUp={false} onChange={v => setFirstSelect(v)} small={true} enabled={isBridge || isReady} buySelect={true} />
       </BuySelectContainer>
          {(chainId !== '0x1') ? (
            <>
              <PendingBuysButton isLoading={safePokt.isLoading} checkPendingBuys={safePokt.checkPendingBuys} />
              <Switch labelOn="ON DEMAND" onChange={handleSwitchValueChange} info="On Demand orders will be fullfilled after 24-48h and share price will be according the real buy price." />
       
              <BuyForm onSubmit={onSubmit}>
                <TradePair
                  disabled={isDisabled}
                  disabledShares={switchValue}
                  minDemand={safePokt.BuyDemandMinAmount}
                  onChange={onTradeInputChange}
                  coins={[
                      {
                          image: 'POKT',
                          name: 'SHARES',
                          value: buyInputs.SHARES,
                          min: '1',
                      },
                      { image: 'USDC', name: 'USDC', value: buyInputs.USDC },
                  ]}
                />
                <DiscountWrapp>
                   {totaldiscountUSDC !== 0 && (
                   <TotalDiscount>
                      {`You are saving ${numberFormatter({
                          number: totaldiscountUSDC,
                      })} USDC (${numberFormatter({ number: discountPercentage })}%)`}
                   </TotalDiscount>
                   )}
                </DiscountWrapp>

                <UnderPairRow className={switchValue ? 'switchOn' : ''}>
                   <div>
                      <ExchangeRate disabled={isDisabled}>
                          <RateIcon />
                          {'1 Share = '}
                          {safePokt.isLoading ? (
                              <Skeleton />
                          ) : (
                              numberFormatter({ number: sharePrice, maxFractionDigits: 4 })
                          )}
                          {` USDC`}
                      </ExchangeRate>
                   </div>
                   <ButtonRow>
                      <Button
                          onClick={() => {
                              setBuyInputValue('SHARES', DSharesPerNode.toString())
                              let totalusdc
                              if (!switchValue) {
                                  totalusdc = SHAREStoUSDCdiscount(
                                      DSharesPerNode,
                                      maxDiscountShares,
                                      safePokt.nodeDiscount,
                                      safePokt.poktBuyPrice,
                                      safePokt.getPoktPerShare
                                  )
                              } else {
                                  totalusdc = (realPoktPrice * safePokt.getPoktPerShare) * DSharesPerNode
                              }
                              setBuyInputValue('USDC', totalusdc.toString())
                          }}
                          type='button'
                          disabled={buttonsDisabled}
                      >
                          1 Node
                      </Button>
                   </ButtonRow>
                </UnderPairRow>
                <ButtonContainer>
                  {disabledInfo && <Warning>{disabledInfo}</Warning>}
                  {hasEnoughAllowance ? (
                      <BuyButton
                          type={'submit'}
                          disabled={isDisabled || isTransacting || !hasEnoughBalance || (minDemandAmount)}
                      >
                          {switchValue ? (isTransacting ? 'Buying Shares On Demand...' : 'Buy Shares On Demand') : (isTransacting ? 'Buying Shares...' : 'Buy Shares')}
                      </BuyButton>
                  ) : (
                      <BuyButton disabled={buttonsDisabled} onClick={onApprove}>
                          {isTransacting ? 'Approving...' : 'Approve'}
                      </BuyButton>
                  )}
                </ButtonContainer>
              </BuyForm>  
            </>
          ) : (
            <>
              <BuyForm onSubmit={onSubmitEth}>
                  <TradePair
                      disabled={isDisabledEth}
                      disabledShares={false}
                      onChange={onTradeInputChangeEth}
                      coins={[
                          { image: 'POKT', name: 'SHARES', value: buyInputsEth.SHARES },
                          { image: 'WPOKT', name: 'WPOKT', value: buyInputsEth.WPOKT },
                      ]}
                  />
                  
                  <UnderPairRow>
                      <div>
                          <ExchangeRate disabled={isDisabledEth}>
                              <RateIcon />
                              {'1 Share = '}
                              {safePokt.isLoading ? (
                                  <Skeleton />
                              ) : (
                                  numberFormatter({ number: sharePriceEth, maxFractionDigits: 4 })
                              )}
                              {` WPOKT`}
                          </ExchangeRate>
                      </div>
                      <ButtonRow>
                          <Button
                              onClick={() => {
                                  setBuyInputValueEth('SHARES', DSharesPerNode.toString())
                                  const totalwpokt = Number(DSharesPerNode) * Number(safePokt.getPoktPerShare)
                                  setBuyInputValueEth('WPOKT', totalwpokt.toString())
                              }}
                              type='button'
                              disabled={buttonsDisabledEth}
                          >
                              1 Node
                          </Button>
                      </ButtonRow>
                  </UnderPairRow>
                  <ButtonContainer>
                      {disabledInfoEth && <Warning>{disabledInfoEth}</Warning>}
                      {hasEnoughAllowanceEth ? (
                          <BuyButton
                              type={'submit'}
                              disabled={isDisabledEth || isTransacting || !hasEnoughBalanceEth}
                          >
                              {isTransacting ? 'Buying Shares...' : 'Buy Shares'}
                          </BuyButton>
                      ) : (
                          <BuyButton disabled={buttonsDisabledEth} onClick={onApproveEth}>
                              {isTransacting ? 'Approving...' : 'Approve'}
                          </BuyButton>
                      )}
                  </ButtonContainer>
              </BuyForm>
            </> 
          )}
   
    </BuyCard>
  )
}
